/**
 * SidebarTags — exibe chips de tags do contato na sidebar (estilo simplificado).
 * Ordena: status > outras > general, limita a `maxTags`, trunca nome longo.
 * Extraído de Chat.tsx.
 */

import React from 'react';
import { TagResponse } from '../../services/apiTags.ts';

interface SidebarTagsProps {
  tags?: TagResponse[];
  maxTags?: number;
  className?: string;
}

const SidebarTags: React.FC<SidebarTagsProps> = React.memo(
  ({ tags = [], maxTags = 2, className = '' }) => {
    if (!tags || tags.length === 0) return null;

    const generalTags: TagResponse[] = [];
    const otherTags: TagResponse[] = [];

    tags.forEach((tag) => {
      if (tag.category === 'general') {
        generalTags.push(tag);
      } else {
        otherTags.push(tag);
      }
    });

    const sortedOther = otherTags.sort((a, b) => a.name.localeCompare(b.name));
    const sortedGeneral = generalTags.sort((a, b) => a.name.localeCompare(b.name));

    const sortedTags = [...sortedOther, ...sortedGeneral].slice(0, maxTags);

    return (
      <div className={`flex flex-wrap items-center gap-1 ${className}`}>
        {sortedTags.map((tag) => (
          <span
            key={tag.id}
            className="inline-flex items-center px-1.5 py-0.25 rounded-full text-xs font-medium flex-shrink-0 border"
            style={{
              backgroundColor: tag.color + '20',
              color: tag.color,
              borderColor: tag.color + '40',
            }}
            title={tag.name}
          >
            {tag.name.length > 8 ? tag.name.substring(0, 7) + '…' : tag.name}
          </span>
        ))}
      </div>
    );
  }
);

SidebarTags.displayName = 'SidebarTags';

export default SidebarTags;
